export const adminHeaders = [
  { key: "firstName", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "email", label: "Email" },
];

export const eltHeaders = [
  { key: "firstName", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "email", label: "Email" },
  { key: "remove", label: "Remove", width: "6%" },
];

export const deptOwnersHeaders = [
  { key: "departmentName", label: "Departments" },
  { key: "firstName", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "email", label: "Email" },
  { key: "add", label: "Add", sortable: false },
  { key: "remove", label: "Remove" },
];
